import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import EasyForm, { FormType } from "../../../../components/Forms/EasyForm";
import EasyFormColumn from "../../../../components/Forms/EasyFormColumn";
import { TextRenderer } from "../../../../components/Forms/Renders/TextRenderer";

import { useAddRecordMutation, useGetRecordByIdQuery } from "../../redux/dnsApiSlice";
import { DnsCreateTXTResponse } from "../../../../models/dns";


export interface InfoTabProps {
    recordUuid: string
}

export default function InfoTab(props: InfoTabProps) {
    const { t } = useTranslation();

    const record = useGetRecordByIdQuery(props.recordUuid, { skip: !props.recordUuid })

    const schema = Yup.object().shape({
        uuid: Yup.string().required("Id is required"),
        fqdn: Yup.string().required("FQDN is required"),
        value: Yup.string().required("Value is required"),
        ttl: Yup.number()
            .typeError("TTL must be a number")
            .integer("TTL must be an integer")
            .positive("TTL must be a positive number")
            .required("TTL is required")
    });

    return (
        <EasyForm<any>
            initialValue={record.data}
            isAllowedToEdit={() => false}
            saveMutation={useAddRecordMutation}
            //getByIdAction={useGetRecordByIdQuery}
            arrayPath=""
            SignupSchema={schema}
            columns={[
                new EasyFormColumn("Record information", "", [
                    new TextRenderer({
                        displayText: "Id",
                        fieldName: "uuid",
                        uniqueId: props.recordUuid,
                    }),
                    new TextRenderer({
                        displayText: "FQDN",
                        fieldName: "fqdn",
                        uniqueId: props.recordUuid,
                    }),
                    new TextRenderer({
                        displayText: t("Value"),
                        fieldName: "value",
                        uniqueId: props.recordUuid,
                    }),
                    new TextRenderer({
                        displayText: "TTL",
                        fieldName: "ttl",
                        uniqueId: props.recordUuid,

                    })
                ])
            ]}
            createNew={() => new DnsCreateTXTResponse()}
            idToFetch={props.recordUuid}
            getFieldRows={() => []}
            newButtonTooltip="Add new info"
            formType={FormType.INFORMATION}
            key={"record_id"}
        />
    )
}
